export default {url: "https://www.krisscode.fr/api/"}
//export default {url: "http://localhost:3004/"}
